import {Link} from 'react-router-dom'
import LogoItProfis from '../components/LogoItProfis'

export const CheckYourEmail = () => {
  return (
    <section className='formcolumn wf-section'>
      <div className='form-login w-form'>
        <Link to='/'>
          <span className='back-button w-inline-block' />
        </Link>
        <div
          id='email-form'
          className='form-content'
          data-wf-page-id='64af252d3146e7d5debe0888'
          data-wf-element-id='ac417b8a-12e2-2eb3-27e8-231ec1120128'
        >
          <div>
            <h2 className='h2-titles' style={{fontSize: '50px'}}>
              POR FAVOR REVISE SU CORREO ELECTRÓNICO PARA CONTINUAR
            </h2>
            <div>Hemos enviado un enlace de recuperación de cuenta</div>
          </div>
          <div className='form-separator'></div>
          <div className='m buttons-div'>
            <Link to='/' className='m button w-inline-block'>
              <div>Aceptar</div>
            </Link>
          </div>
        </div>
      </div>
      <LogoItProfis />
    </section>
  )
}
